import React, { Component } from 'react';
import Button from 'bee-button';

require('bee-button/build/Button.css');
require('./nc_button.less');
//import $NCPE from '../../pe/pe.js';

export default class NCButton extends Component {
	render() {
		let { onClick, fieldid, is_arrow, colors = 'weishabushezhiyigemoren', className = '', tabIndex = '-1', ...others } = this.props,
			childContent = this.props.children;
		let { shape } = this.props;
		if (fieldid) {
			if (is_arrow) {
				fieldid = fieldid + '-arrow_btn';
			} else {
				fieldid = fieldid + '_btn';
			}
		}
		let classname  = `${className} nc-button-wrapper button-${colors} ${shape == 'icon' ? 'bt-icon' : ''} `;
		return (
			<Button
				fieldid={fieldid}
				onClick={(e) => {
					// 这里呢 当是弹窗内的确定取消按钮时  children 会是一个 react对象
					// 所以这里需要判断下情况  modify by bbqin
					let $target = e.target || e.currentTarget || {};
					if (typeof childContent === 'string') {
						window.actionName = childContent;
					} else {
						window.actionName = $target.innerText || (childContent && childContent[0] ? childContent[0] : '按钮内部没有内容') || childContent;
					}
					if (window.top.proxyAction) {
						window.top.proxyAction(onClick, this, this.props.children)(e);
					} else if (typeof onClick === 'function') {
						onClick(e);
						//$NCPE.proxy(onClick, this, this.props.children)(e);
					}
				}}
				className={classname}
				tabIndex={tabIndex}
				{...others}
			/>
		);
	}
}
